<template>
  <div>
    <masthead></masthead>
    <introduction></introduction>
    <banner-slideshow></banner-slideshow>
    <brands></brands>
    <!-- <testimonial></testimonial> -->
    <section>
      <iframe
        width="100%"
        height="600"
        frameborder="0"
        style="border: 0; border-bottom:1px solid rgba(0,0,0,0.10); margin-bottom: -6px;"
        src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJvQ1quUltZ0gRt0TFDlbeBw4&key=AIzaSyCkV1-FpqZIfbJaXeL9EKe71f0b2KyI0Ao"
        allowfullscreen
      ></iframe>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Carousel, Slide } from "vue-carousel";
import Masthead from "./landing/Masthead";
import Introduction from "./landing/Introduction";
import BannerSlideshow from "./landing/BannerSlideshow";
import Brands from "./landing/Brands";
import Testimonial from "./landing/Testimonial";

export default {
  components: {
    Carousel,
    Slide,
    Masthead,
    Introduction,
    BannerSlideshow,
    Brands,
    Testimonial
  },
  methods: mapActions(["fetchLandingPage"]),
  mounted() {
    this.fetchLandingPage();
  }
};
</script>

<style lang="scss">
</style>
